var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.4,0.4h20.2v20.2H0.4V0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4,10.5C2.2,6.2,6,2.9,10.5,2.9s8.3,3.3,9.1,7.6c-0.8,4.3-4.6,7.6-9.1,7.6S2.2,14.8,1.4,10.5z M10.5,14.7 c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2s-4.2,1.9-4.2,4.2S8.2,14.7,10.5,14.7z M10.5,13C9.1,13,8,11.9,8,10.5S9.1,8,10.5,8 S13,9.1,13,10.5S11.9,13,10.5,13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFillIcon);
export default __webpack_public_path__ + "static/media/eye_fill_icon.905b2f69035f41677344d8a95a5ed719.svg";
export { ForwardRef as ReactComponent };